var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_860_283",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_860_283",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAB2AAAAdgB+lymcgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAPeSURBVHic5dpLiBxFHMfxz4yaGGNc4yPriqgYPfjAB2giigZlDYlEwZtIfIBgxJNeFBFFTx4ETQ6isCheNOADD2KECF5EyEFxiYIefExAI4qrkqxGXXU99C5MJt3TNd3V0z2bLxQDPfX/9///6+qq6qpitNiML/A73sWZ9YYzXNZgFvNd5Z1aIxoyNzs8+XmJIKVol3UwRMZTrq0s63SUBDirCqejJMCVdQdQJ6skPX9vHzBf1vGotID7cULdQdTFxbKffukW0HTG8bns5Je0AJeio3/yRQRYi5uwOkqUFbAGO/CX/OQHEeBqvNdlN4NrokVdknNwB97GIWGJhwrQm3h3+aSVY7wWmxZ+x3HcAEn1o40xnLLge6yEr6wcLsEzkvizOJD1x2Z8bLAnUVdJ4yr9R47F8mav4YkLF+tOqqwALwXY7cJp3Uar8WkDEoohwIt96n+A63sNjsXuBiQTS4DLHTmKpCa+yIMNSCSmALAOL+N5XJdVqYWT8LWe92GEyBvJ+tLGbUY3+dK0cUvdQdRJWzLnPmppY6LuIOqkLZn8LDXaeBr7pY8cs3jDQt9X9zBWxTB4T6Dt66OyJDYoGwLrbVyqAuwLrPcN9TfhKl6BU/FZjt0Mrm1J5szLAhVrIlkzweWSvYS0DdRZ7MGvLUlzObua2IZC6anwt5ECGUnakvWyo5YWzseXOKbmWIpS+hX4Cq9ECaVZLJcsiG4QsJg7IXva2PSSxhj2dtXpYJuc0W49/mhAQjEEeCKjbgf39RNivdFrCWm8mmPTkXwvpHIGpvBPA5IrKsC9gbZPZYkA5+FhyWrqPuF7dU0QoIVH5b/SP/cToEpakn2IczGJh/CWsN2cEAEWmcB22UL8GC+lOKzE3ZKvtBgCLJIlxOMRY4/KMjwmrB8ahAk8Itk626rkJGoYbHHk6dAyAgzM8VXfIIC7VChAXhPYLflU/h6/4d9Av39KhqK54qEdxk7cnvFfpc14i+LD09aIcVyA/zLuUyktyfH0IgJMi/t09mTcpxR5i6LzeK6g78uwsaBtGh9G9DUQK/CTYq3g/YhxbMu4RylClsUP4YWC/idxRUHbXn5JuRbaKZdm3ODH1xbLa5FiuDDF995IvoOYSgkgpMxJzgHGYEeX3wPi9jG5XCR7KMor2yPHsQmnR/QZzC7FBDiIk2uINzqTik+M7qwh3kqYVkyAqTqCzaPI7vCzBe/VyFegiAA78V0Bu/0FbCqniABzksOHg/JRAZvGsgo/CH//O+IdtW8MNwpbxPwbN9QUY+Ws038jZQa31hbdkFiBByTf6wcXyjSeNAJnEP8H6vvvkvtycTAAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.5bce832ad3dc68813f990d107fe98db9.svg";
export { ForwardRef as ReactComponent };